<template>
    <div id="layout-guest" :style="{ minHeight: layoutHeight + 'px' }">

        <div class="guest_top_bar">
            <div class="logo_container">
                <img src="@/assets/saven_potentiel_picto.png" />
            </div>
        </div>


        <div class="content_page_section flex flex_content">
            <slot/>
        </div>

    </div>
</template>

<script>
import LogoSharp from './logoSharp'


export default {
    name: 'layoutGuest',
    components: {
        LogoSharp
    },
    data() {
        return {
            layoutHeight: window.innerHeight
        }
    },
    methods: {
        handleResize() {
            this.layoutHeight = window.innerHeight;
        }
    }
}
</script>

<style lang="scss">
html{
    overflow: auto!important;
}
#layout-guest{
    display: flex;
    flex-direction: column;
    .guest_top_bar{
        background: white;
        height: 108px;
        .logo_container{
            width: 80px;
            margin: auto;
            padding: 12px 0;
            svg{
                fill: $white;
            }
        }
    }
}
</style>